import { ReactNode } from 'react';

import { Box, Flex, FlexProps, Heading, HeadingProps, Text, TextProps } from '@chakra-ui/react';

export type FeatureCardProps = {
  isReversed: boolean;
  themeColor: string;
  icon: ReactNode;
  subtitle: string;
  title: string;
  description: string;
  imageSlot: ReactNode;
  containerProps?: FlexProps;
  contentProps?: FlexProps;
  titleProps?: HeadingProps;
  descriptionProps?: TextProps;
  ctaSlot?: ReactNode;
};

export function FeatureCard({
  isReversed,
  themeColor,
  icon,
  subtitle,
  title,
  description,
  imageSlot,
  containerProps,
  contentProps,
  titleProps,
  descriptionProps,
  ctaSlot = null,
}: FeatureCardProps) {
  return (
    <Flex
      alignItems='center'
      gap={{ base: 4, md: '64px' }}
      padding={{ base: 4, md: 8 }}
      direction={{
        base: 'column-reverse',
        md: isReversed ? 'row-reverse' : 'row',
      }}
      {...containerProps}
    >
      <Flex
        alignSelf='stretch'
        flex={{ md: '0 2 404px' }}
        flexDirection='column'
        gap={4}
        padding={{ md: 4 }}
        {...contentProps}
      >
        <Flex flex='1' flexDirection='column' gap={{ base: 3, md: 4 }}>
          <Heading
            alignItems='center'
            as='p'
            color={themeColor}
            display='flex'
            fontFamily='condensed'
            fontSize='0.8125rem'
            fontWeight='500'
            gap={3}
            letterSpacing='.8px'
            lineHeight='1'
            textTransform='uppercase'
            _after={{
              content: '""',
              display: 'block',
              width: '100%',
              height: '1px',
              backgroundColor: themeColor,
              flex: '1',
            }}
          >
            {icon}
            <Box as='span' whiteSpace='nowrap'>
              {subtitle}
            </Box>
          </Heading>
          <Heading
            as='h3'
            color='grey.900'
            fontSize={{ base: '1.75rem', md: '2.25rem' }}
            fontWeight='600'
            letterSpacing='-1px'
            lineHeight='1.1'
            {...titleProps}
          >
            {title}
          </Heading>
          <Text color='grey.500' {...descriptionProps}>
            {description}
          </Text>
          {ctaSlot}
        </Flex>
      </Flex>
      {imageSlot}
    </Flex>
  );
}
